import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  CreateSfWalletRequestDto,
  CreateSfWalletResponseDto,
  ReadSfWalletsRequestDto,
  ReadSfWalletsResponseDto,
  UpdateSfWalletRequestDto,
  UpdateSfWalletResponseDto,
  ReadUserSfWalletsRequestDto,
  ReadUserSfWalletsResponseDto,
  AssignSfWalletToUserRequestDto,
  AssignSfWalletToUserResponseDto,
  UnassignSfWalletFromUserRequestDto,
  UnassignSfWalletFromUserResponseDto,
} from '@sparling/financial-common'

export const {
  request: getSfWalletsRequest,
  success: getSfWalletsSuccess,
  failure: getSfWalletsFailure,
} = createAsyncAction('GET_SF_WALLETS_REQUEST', 'GET_SF_WALLETS_SUCCESS', 'GET_SF_WALLETS_FAILURE')<
  ReadSfWalletsRequestDto,
  ReadSfWalletsResponseDto,
  Error
>()

export const {
  request: createSfWalletRequest,
  success: createSfWalletSuccess,
  failure: createSfWalletFailure,
} = createAsyncAction('CREATE_SF_WALLET_REQUEST', 'CREATE_SF_WALLET_SUCCESS', 'CREATE_SF_WALLET_FAILURE')<
  CreateSfWalletRequestDto,
  CreateSfWalletResponseDto,
  Error
>()

export const {
  request: updateSfWalletRequest,
  success: updateSfWalletSuccess,
  failure: updateSfWalletFailure,
} = createAsyncAction('UPDATE_SF_WALLET_REQUEST', 'UPDATE_SF_WALLET_SUCCESS', 'UPDATE_SF_WALLET_FAILURE')<
  UpdateSfWalletRequestDto,
  UpdateSfWalletResponseDto,
  Error
>()

export const {
  request: getAssignedWalletsByUserRequest,
  success: getAssignedWalletsByUserSuccess,
  failure: getAssignedWalletsByUserFailure,
} = createAsyncAction(
  'GET_ASSIGNED_WALLETS_BY_USER_REQUEST',
  'GET_ASSIGNED_WALLETS_BY_USER_SUCCESS',
  'GET_ASSIGNED_WALLETS_BY_USER_FAILURE',
)<ReadUserSfWalletsRequestDto, ReadUserSfWalletsResponseDto, Error>()

export const {
  request: getAssignedWalletIdsByUserRequest,
  success: getAssignedWalletIdsByUserSuccess,
  failure: getAssignedWalletIdsByUserFailure,
} = createAsyncAction(
  'GET_ASSIGNED_WALLET_IDS_BY_USER_REQUEST',
  'GET_ASSIGNED_WALLET_IDS_BY_USER_SUCCESS',
  'GET_ASSIGNED_WALLET_IDS_BY_USER_FAILURE',
)<{ idSf: string }, number[], Error>()

export const {
  request: assignSfWalletToUserRequest,
  success: assignSfWalletToUserSuccess,
  failure: assignSfWalletToUserFailure,
} = createAsyncAction(
  'ASSIGN_SF_WALLET_TO_USER_REQUEST',
  'ASSIGN_SF_WALLET_TO_USER_SUCCESS',
  'ASSIGN_SF_WALLET_TO_USER_FAILURE',
)<AssignSfWalletToUserRequestDto, AssignSfWalletToUserResponseDto, Error>()

export const {
  request: unassignSfWalletFromUserRequest,
  success: unassignSfWalletFromUserSuccess,
  failure: unassignSfWalletFromUserFailure,
} = createAsyncAction(
  'UNASSIGN_SF_WALLET_FROM_USER_REQUEST',
  'UNASSIGN_SF_WALLET_FROM_USER_SUCCESS',
  'UNASSIGN_SF_WALLET_FROM_USER_FAILURE',
)<UnassignSfWalletFromUserRequestDto, UnassignSfWalletFromUserResponseDto, Error>()

export const resetSfWalletFilters = createAction('RESET_SF_WALLET_FILTERS')<undefined>()
